import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { Box, Text, Container, Flex, VStack, Stack, Heading } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';
import { TermsScreen } from './termsScreen';
import BtHelmet from '../../components/BtHelmet';
import BtLoading from '../../components/BtLoading';
import { BtNavigate } from '../../components/BtNavigate';
import { LandingScreen } from '../landing/landingScreen';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../app/store';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import remarkBreaks from 'remark-breaks';

export const Terms: React.FC = () => {
  const viewModel = useAppSelector((state) => state.terms.viewModel);
  const logoUrl = useSelector((state: RootState) => state.gatInformation.logoUrl);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (TermsScreen.isNone(viewModel)) {
      dispatch(TermsScreen.start(viewModel, logoUrl));
    } else if (TermsScreen.isLoading(viewModel)) {
      (async () => {
        dispatch(await TermsScreen.load(viewModel, logoUrl));
      })();
    }
  }, [viewModel]);

  const handleNavigate = async (path: string) => {
    if (path.length === 0) {
      navigate(-1);
    } else {
      dispatch(await LandingScreen.reset(logoUrl));
      navigate(path);
    }
  };

  const { t } = useTranslation();

  if (TermsScreen.isReady(viewModel)) {
    return (
      <>
        <BtHelmet title={viewModel.metaTitle} />
        <Container padding={0} size='xl'>
          <BtNavigate {...viewModel.navigation} onClick={handleNavigate} />
          <Container padding={0} maxW='container.lg'>
            <Flex pb={200}>
              <VStack w='full' h='full' p={4}>
                <Box w='100%'>
                  <VStack w='100%'>
                    <Heading pb={3} as='h1' variant='h1'>
                      {viewModel.title}
                    </Heading>
                    <Stack
                      w='full'
                      spacing={5}
                      direction={['column', 'column']}
                      p={1}
                      alignItems='center'
                    >
                      <Box w='100%' p={[7, 10]} bg='black' borderRadius='lg' boxShadow='brand'>
                        <ReactMarkdown
                          children={t('termsScreen.terms')}
                          components={{
                            br: () => <br />,
                            p: ({ node, ...props }) => (
                              <p style={{ marginBottom: '1em' }} {...props} />
                            ),
                          }}
                          skipHtml={false}
                        />
                      </Box>
                    </Stack>
                  </VStack>
                </Box>
              </VStack>
            </Flex>
          </Container>
        </Container>
        )
      </>
    );
  } else {
    return <BtLoading {...viewModel.loading} />;
  }
};
